import { lazyNamed } from 'src/utils/lazyNamed';

export const AdTypes = {
  List: lazyNamed(() => import('./containers/AdTypesList'), 'AdTypesList'),
  Edit: lazyNamed(() => import('./containers/AdTypeEdit'), 'AdTypeFormPage'),
};
